// extracted by mini-css-extract-plugin
export default {"wrapper":"subCards_wrapper__2z+YL","wrapper_child":"subCards_wrapper_child__ZqYyS","sub_parent":"subCards_sub_parent__Podaq"};